module.exports = __webpack_public_path__ + "img/20180815_151629_191.a6e59c54.jpg";